import { render, staticRenderFns } from "./my-customer-details.vue?vue&type=template&id=3f65a7d8&"
import script from "./my-customer-details.vue?vue&type=script&lang=js&"
export * from "./my-customer-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports